import { emitter } from '@backmarket/design-system'
import isEmpty from 'lodash.isempty'

import {
  trackCarouselImpression,
  trackClick,
  trackModal,
  trackToast,
} from '@tracking/events'

const clickListeners = ({ context }) => {
  if (!isEmpty(context.tracking) || !isEmpty(context.name)) {
    const tracker = {
      // If a name is set (for a button for example) we can automate the tracking using it
      name: context.name,
      // If some tracking properties has been set, let's forward it to the trackClick event
      ...context.tracking,
    }

    trackClick(tracker)
  }
}

const listeners = (action, { context }) => {
  switch (action) {
    case 'click':
      clickListeners({ context })
      break

    case 'modal':
      trackModal(context)
      break

    case 'toast':
      trackToast(context)
      break

    case 'carousel-impression': {
      const { currentSlide, tracking } = context

      if (!isEmpty(tracking)) {
        const { name, creatives } = tracking

        const creative = !isEmpty(creatives)
          ? creatives[currentSlide]?.creative
          : ''

        trackCarouselImpression({
          name,
          creative,
          position: `${name}_${currentSlide}`,
        })
      }

      break
    }

    default:
      break
  }
}

// The design system exports a pub/sub (emitter) where we can use as hooks.
// These hooks allow us to define the tracking strategy once for all of the DS components.
export const trackDesignSystem = () => {
  emitter.on('*', listeners)
}

export const untrackDesignSystem = () => {
  emitter.off('*', listeners)
}
